const carouselSettings = {
  infinite: true,
  dots: false,
  arrows: true,
  slidesToShow: 1,
};

export default carouselSettings;
